/* Brique Favoris (toutes les pages), chargée par la section « Lien Favoris (cœur) ».
   1. Sans consentement cookies, un clic sur un cœur Wishlist Plus est bloqué et le panneau de cookies Consentmo est rouvert.
   2. Les notifications d'ajout / retrait de favori affichent la photo principale du bijou.
   Réglages : window.ChaminiFavorisConfig (écrit par la section). Expose window.ChaminiFavoris pour la page Mes favoris. */
(function () {
  'use strict';
  if (window.ChaminiFavoris) return;

  var cfg = window.ChaminiFavorisConfig || {};
  var category = cfg.consentCategory || 'preferences';
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Cœurs de l'appli (fiche produit, cartes produit, boutons ajoutés par l'appli). */
  var HEART_SELECTOR = [
    '.swym-button',
    '.swym-add-to-wishlist',
    '.swym-add-to-wishlist-view-product',
    '[id*="wishlist_pdp_button"]',
    '[class*="swym-collections"] button',
    'button[class*="swym-collections"]',
    '[class*="swym-collections-btn"]',
    '[data-chamini-favoris-action]'
  ].join(',');
  if (cfg.extraSelectors) HEART_SELECTOR += ',' + cfg.extraSelectors;

  /* Notifications volantes de l'appli (sélecteurs larges, le HTML de l'appli n'est pas documenté). */
  var NOTIF_SELECTOR = '[class*="swym"][class*="otif"], [id*="swym"][id*="otif"], [class*="swym"][class*="toast"], [id*="swym"][id*="toast"]';

  function closest(el, sel) {
    try { return el && el.closest ? el.closest(sel) : null; } catch (e) { return null; }
  }

  function handleFromUrl(url) {
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* ---------- Consentement (API Shopify Customer Privacy, alimentée par Consentmo) ---------- */
  var consent = null; // true / false, ou null si inconnu

  function privacyApi() {
    return (window.Shopify && window.Shopify.customerPrivacy) || null;
  }

  function readConsent() {
    var api = privacyApi();
    if (!api) return null;
    var fn = { preferences: 'preferencesProcessingAllowed', analytics: 'analyticsProcessingAllowed', marketing: 'marketingAllowed' }[category] || 'preferencesProcessingAllowed';
    try { if (typeof api[fn] === 'function') return !!api[fn](); } catch (e) {}
    try { if (typeof api.userCanBeTracked === 'function') return !!api.userCanBeTracked(); } catch (e) {}
    return null;
  }

  function loadPrivacyApi(cb) {
    if (privacyApi()) return cb();
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { cb(); });
        return;
      }
    } catch (e) {}
    cb();
  }

  function notifyConsent() {
    try { document.dispatchEvent(new CustomEvent('chamini:favoris-consent', { detail: { allowed: consent } })); } catch (e) {}
  }

  function refreshConsent(cb) {
    loadPrivacyApi(function () {
      var before = consent;
      var now = readConsent();
      if (now !== null) consent = now;
      if (before !== consent) notifyConsent();
      if (cb) cb(isAllowed());
    });
  }

  /* Consentement inconnu (API absente) : on laisse faire, pour ne pas casser les favoris. */
  function isAllowed() {
    if (!cfg.consentGate) return true;
    return consent !== false;
  }

  /* Rouvre le panneau de cookies : bannière Chamini si elle est active (window.ChaminiCookies),
     sinon Consentmo (fonction documentée showPreferences), sinon des solutions de repli. */
  function openConsent(source) {
    try {
      if (window.ChaminiCookies && typeof window.ChaminiCookies.openPreferences === 'function') { window.ChaminiCookies.openPreferences(); return true; }
    } catch (e) {}
    try {
      if (typeof window.showPreferences === 'function') { window.showPreferences(source || document.body); return true; }
    } catch (e) {}
    var btn = document.querySelector('.isense-reopen-widget-button, [class*="isense"][class*="reopen"], [class*="cc-revoke"], [data-consentmo-reopen]');
    if (btn) { try { btn.click(); return true; } catch (e) {} }
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') { window.privacyBanner.showPreferences(); return true; }
    } catch (e) {}
    return false;
  }

  /* Événement Consentmo : detail = choix du visiteur (functionality / analytics / marketing). */
  document.addEventListener('consentmoSignal', function (evt) {
    var d = (evt && evt.detail) || {};
    var key = { preferences: 'functionality', analytics: 'analytics', marketing: 'marketing' }[category];
    if (key && typeof d[key] === 'boolean') {
      var before = consent;
      consent = d[key];
      if (before !== consent) notifyConsent();
    }
    setTimeout(function () { refreshConsent(); }, 300);
  });
  /* Événement Shopify après un choix de cookies. */
  document.addEventListener('visitorConsentCollected', function () { setTimeout(function () { refreshConsent(); }, 100); });
  /* Événement de la bannière cookies Chamini après un choix. */
  document.addEventListener('chamini:consent-changed', function () { setTimeout(function () { refreshConsent(); }, 100); });

  /* ---------- Photo principale du bijou ---------- */
  var imageCache = {};
  if (cfg.productHandle && cfg.productImage) imageCache[cfg.productHandle] = Promise.resolve(cfg.productImage);

  function normalizeUrl(u) {
    if (!u) return null;
    u = String(u);
    return u.indexOf('//') === 0 ? 'https:' + u : u;
  }

  function featuredImage(handle) {
    if (!handle) return Promise.resolve(null);
    if (!imageCache[handle]) {
      imageCache[handle] = fetch(shopRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return null;
          var src = p.featured_image || (p.images && p.images[0]) || (p.media && p.media[0] && p.media[0].src);
          return normalizeUrl(src);
        })
        .catch(function () { return null; });
    }
    return imageCache[handle];
  }

  var lastProduct = null; // { handle, at }

  function remember(handle) {
    if (!handle) return;
    lastProduct = { handle: handle, at: Date.now() };
    featuredImage(handle); // préchargement
  }

  function handleFromHeart(el) {
    if (closest(el, '[id*="wishlist_pdp_button"], .product__info-wrapper, product-info') && cfg.productHandle) return cfg.productHandle;
    var card = closest(el, '.card-wrapper, .product-card-wrapper, .card, .grid__item, li');
    var link = card && card.querySelector('a[href*="/products/"]');
    if (link) return handleFromUrl(link.getAttribute('href'));
    return cfg.productHandle || null;
  }

  /* ---------- Clic sur un cœur (phase de capture, avant l'appli) ---------- */
  function onHeartClick(evt) {
    var heart = closest(evt.target, HEART_SELECTOR);
    if (!heart) return;
    remember(handleFromHeart(heart));
    if (!cfg.consentGate) return;
    var now = readConsent();
    if (now !== null) consent = now;
    if (consent === false) {
      evt.preventDefault();
      evt.stopPropagation();
      if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      openConsent(heart);
    }
  }
  window.addEventListener('click', onHeartClick, true);

  /* ---------- Notifications : remplace l'image par la photo principale ---------- */
  function setImage(img, url) {
    if (!img || !url || img.getAttribute('data-chamini-src') === url) return;
    img.setAttribute('data-chamini-src', url);
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  function fixNotification(box) {
    if (!box || !cfg.fixNotificationImage) return;
    var link = box.querySelector('a[href*="/products/"]');
    var handle = link ? handleFromUrl(link.getAttribute('href')) : null;
    if (!handle && lastProduct && Date.now() - lastProduct.at < 20000) handle = lastProduct.handle;
    if (!handle) return;
    featuredImage(handle).then(function (url) {
      if (!url) return;
      var imgs = box.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        // On ignore les petites icônes (svg, logos)
        if (/\.svg(\?|$)/i.test(imgs[i].getAttribute('src') || '')) continue;
        setImage(imgs[i], url);
      }
      var bgs = box.querySelectorAll('[style*="background-image"]');
      for (var j = 0; j < bgs.length; j++) {
        if (bgs[j].style.backgroundImage.indexOf(url) === -1) bgs[j].style.backgroundImage = 'url("' + url + '")';
      }
    });
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    var box = closest(node, NOTIF_SELECTOR);
    if (box) return fixNotification(box);
    var inner = node.querySelectorAll ? node.querySelectorAll(NOTIF_SELECTOR) : [];
    for (var i = 0; i < inner.length; i++) fixNotification(inner[i]);
  }

  function startObserver() {
    if (!cfg.fixNotificationImage || !window.MutationObserver || !document.body) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var k = 0; k < m.addedNodes.length; k++) scan(m.addedNodes[k]);
        } else if (m.type === 'attributes' && m.target.tagName === 'IMG') {
          var t = m.target;
          if (t.getAttribute('data-chamini-src') !== t.getAttribute('src') && closest(t, NOTIF_SELECTOR)) scan(t);
        } else if (m.type === 'attributes' && closest(m.target, NOTIF_SELECTOR)) {
          scan(m.target);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'class', 'style'] });
  }

  /* Événements de l'appli : on retient le bijou concerné (champ du = adresse du produit). */
  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function (swat) {
    try {
      if (!swat || !swat.evtLayer || !swat.JSEvents) return;
      var onEvt = function (e) {
        var d = (e && e.detail) || {};
        d = d.d || d;
        var handle = handleFromUrl(d.du || d.url || (d.product && d.product.du));
        if (handle) remember(handle);
        try { document.dispatchEvent(new CustomEvent('chamini:favoris-change')); } catch (err) {}
      };
      ['addedToWishlist', 'removedFromWishlist'].forEach(function (name) {
        if (swat.JSEvents[name]) swat.evtLayer.addEventListener(swat.JSEvents[name], onEvt);
      });
    } catch (e) {}
  });

  window.ChaminiFavoris = {
    isAllowed: function (cb) { refreshConsent(cb); },
    openConsent: openConsent,
    featuredImage: featuredImage,
    handleFromUrl: handleFromUrl
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
  refreshConsent();
  // L'API de consentement peut arriver après le chargement de Consentmo
  setTimeout(function () { refreshConsent(); }, 1500);
  setTimeout(function () { refreshConsent(); }, 4000);
})();
